import { OnboardingCode } from '../constants/OnboardingCode.js';
import { SERVICE_ACCESS_TEMPLATE_CODES } from './ServiceAccessTemplateCode.js';

/**
 * Maps OnboardingCode to ServiceAccessTemplateCode for backwards compatibility.
 * This map is used during migration to convert onboardingCode to the appropriate serviceAccess template.
 */
const ONBOARDING_CODE_TO_SERVICE_ACCESS_TEMPLATE = {
    [OnboardingCode.RENA_OMNI_PROGRAM_2025]: SERVICE_ACCESS_TEMPLATE_CODES.OMNI_ROOFTOP,
    [OnboardingCode.LIVEWIRE_OMNI_PROGRAM_2025]: SERVICE_ACCESS_TEMPLATE_CODES.OMNI_ROOFTOP,
    [OnboardingCode.TEST_PROGRAM]: SERVICE_ACCESS_TEMPLATE_CODES.DEFAULT,
    [OnboardingCode.EKHO_ACCESS_OEM_PROGRAM]: SERVICE_ACCESS_TEMPLATE_CODES.ACCESS_PROGRAM_OWNER,
    [OnboardingCode.EKHO_OMNI_OEM_PROGRAM]: SERVICE_ACCESS_TEMPLATE_CODES.OMNI_PROGRAM_OWNER,
    [OnboardingCode.EVIN_MOTORS_NC]: SERVICE_ACCESS_TEMPLATE_CODES.DEALER_ROOFTOP,
    [OnboardingCode.EVIN_MOTORS_FL]: SERVICE_ACCESS_TEMPLATE_CODES.DEALER_ROOFTOP,
    [OnboardingCode.EUROCYCLE]: SERVICE_ACCESS_TEMPLATE_CODES.DEALER_ROOFTOP,
    [OnboardingCode.CCW]: SERVICE_ACCESS_TEMPLATE_CODES.DEALER_ROOFTOP,
    [OnboardingCode.CARTMART]: SERVICE_ACCESS_TEMPLATE_CODES.DEALER_ROOFTOP,
    [OnboardingCode.UBD]: SERVICE_ACCESS_TEMPLATE_CODES.DEALER_ROOFTOP,
    [OnboardingCode.GENERIC_PROGRAM_OWNER]: SERVICE_ACCESS_TEMPLATE_CODES.ACCESS_PROGRAM_OWNER,
    [OnboardingCode.MASSIMO]: SERVICE_ACCESS_TEMPLATE_CODES.ACCESS_PROGRAM_OWNER,
    [OnboardingCode.STAREV]: SERVICE_ACCESS_TEMPLATE_CODES.ACCESS_PROGRAM_OWNER,
    [OnboardingCode.BDC_DEALER]: SERVICE_ACCESS_TEMPLATE_CODES.DEALER_SOLO_ROOFTOP,
};

export { ONBOARDING_CODE_TO_SERVICE_ACCESS_TEMPLATE };
//# sourceMappingURL=OnboardingCodeToServiceAccess.js.map
